import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Header from './ScenarioBiteHeader';
import Progress  from './ScenarioBiteProgress';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as actionTypes from '../../../actions/actionTypes';
import MainMenu from '../../dialogs/mainMenu/MainMenu';
import Resources from '../../dialogs/resources/Resources';
import Screen from '../../AppScreen';
import * as appHelper from '../../../helpers/appHelper';

class ScenarioBite extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            bite: this.props.bite,
            showHeader: true,
            biteCallbacks: {},
            fontSize: this.props.fontSize,
            height: undefined,
            updateHeight: false,

        };

        this.setBiteCallbacks = this.setBiteCallbacks.bind(this);
        this.showHeader = this.showHeader.bind(this);
        this.getClass = this.getClass.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.getBlurEffect = this.getBlurEffect.bind(this);
        this.setHeight = this.setHeight.bind(this);
        this.getHeight = this.getHeight.bind(this);
    }

    componentDidMount() {
        this.setHeight();
        this.setBiteCallbacks();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.fontSize !== nextProps.fontSize) {
            this.setState({fontSize: nextProps.fontSize, updateHeight: true});
        }
    }

    componentDidUpdate(){
        if(this.state.updateHeight){
            this.setHeight();
        }
    }

    setBiteCallbacks() {
        this.setState({
            biteCallbacks: Object.assign({}, this.state.biteCallbacks, {
                showHeader: this.showHeader,
                getBiteId: this.getBiteId,
                setToolTip: this.setToolTip
            })
        });
    }

    showHeader(show) {
        this.setState({showHeader: show});
    }

    getBiteId() {
        return this.state.bite.bite_id;
    }

    getClass() {
        if (this.state.showHeader) {
            return "screen-wrapper";
        } else {
            return "screen-wrapper full-screen";
        }
    }

    getBlurEffect(){

        if(this.props.dialogPopup.render || this.props.assetDialog.render || this.props.screenDialog.render || this.props.displayResources !== actionTypes.STATUS_CLOSED || this.props.displayMainMenu !== actionTypes.STATUS_CLOSED){
            return 'blur on';
        }else{
            return 'blur off';
        }
    }


    setHeight(){
        this.setState({updateHeight: false});
        let mainWrapper = document.getElementById('main-wrapper');
        let header = document.getElementById('scenarioBiteHeader');
        let progress =  document.getElementById('scenarioBiteProgress');
        if(appHelper.isDefined(header)){
            let newHeight = (mainWrapper.offsetHeight - header.offsetHeight - progress.offsetHeight);
            this.setState({height: newHeight});
        }
    }



    getHeight(){

        if(this.state.showHeader && appHelper.isDefined(this.state.height)){
            return {
                height: `${this.state.height}px`,
                minHeight: `${this.state.height}px`,
            };
        }else{
            return {};
        }
    }



    render() {
        let Dialog = this.props.dialogPopup.component;
        let AssetDialog = this.props.assetDialog.component;
        let ScreenDialog = this.props.screenDialog.component;
        return (
            <div className="scenario-bite">
                {
                    this.state.showHeader
                        ? <Header bite={this.state.bite}/>
                        : null
                }
                {
                    this.state.showHeader
                        ? <Progress bite={this.state.bite}/>
                        : null
                }
                <div className="scenario-bite-content">
                    <div className={`${this.getClass()} ${this.getBlurEffect()}`} id="screenWrapper" style={this.getHeight()}>
                        <Screen bite={this.state.bite} biteCallbacks={this.state.biteCallbacks}/>
                    </div>

                    {this.props.screenDialog.render
                        ? <ScreenDialog />
                        : null
                    }

                    {this.props.dialogPopup.render
                        ? <Dialog />
                        : null
                    }

                    {this.props.displayResources !== actionTypes.STATUS_CLOSED
                        ? <Resources />
                        : null
                    }

                    {this.props.displayMainMenu !== actionTypes.STATUS_CLOSED
                        ? <MainMenu />
                        : null
                    }

                    {this.props.assetDialog.render
                        ? <AssetDialog />
                        : null
                    }
                </div>
            </div>
        );
    }
}

ScenarioBite.propTypes = {
    bite: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    dialogPopup: PropTypes.object.isRequired,
    displayMainMenu: PropTypes.string.isRequired,
    displayResources: PropTypes.string.isRequired,
    assetDialog: PropTypes.object.isRequired,
    screenDialog: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    fontSize: PropTypes.object.isRequired,
};

ScenarioBite.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        trackingData: state.trackingData,
        dialogPopup: state.dialogPopup,
        displayMainMenu: state.displayMainMenu,
        displayResources: state.displayResources,
        assetDialog: state.assetDialog,
        screenDialog: state.screenDialog,
        fontSize: state.fontSize
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ScenarioBite);



/** WEBPACK FOOTER **
 ** ./src/components/bites/ScenarioBite/ScenarioBite.js
 **/